var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 26,
  height: 20,
  viewBox: "0 0 26 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#528AEA",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.53 6.663h11.82V5.109H3.53l2.883-2.9a.778.778 0 1 0-1.104-1.095L.561 5.886l4.748 4.771A.777.777 0 1 0 6.413 9.57L3.53 6.663zM16.966 5.109h2.331v1.554h-2.331zM20.851 5.109h1.555v1.554H20.85zM20.79 9.662a.778.778 0 0 0-1.104 1.096l2.883 2.899h-11.82v1.554h11.82l-2.883 2.906a.777.777 0 1 0 1.103 1.088l4.725-4.771-4.725-4.772zM6.863 13.657h2.332v1.554H6.863zM3.755 13.657h1.554v1.554H3.755z"
}))));
export default __webpack_public_path__ + "teg/media/switch-line.b51f4800.svg";
export { SvgComponent as ReactComponent };